/**
 * This function takes a list of filter options
 * from the useFilterOptions data hook, and does a few things:
 * 1. ignores columns with no real values
 * 2. puts up to 5 columns into "coreFilters" list,
 *    and any other columns into "moreFilters" list,
 *    to be revealed when "More filters" button is clicked
 */
import { FilterOptions } from 'dataHooks/useFilterOptions'

export interface Filter {
  filterName: string
  distinct: string[]
}

function getFilters(filterOptions: FilterOptions) {
  const maxNumCoreFilters = 5
  // list of filters initally shown
  const coreFilters: Filter[] = []
  // list of the rest of the filters
  const moreFilters: Filter[] = []

  // map through filterOptions and get rid of:
  // 1. Filters who don't have corresponding cols in Airtable (don't exist)
  // 2. Default filter values of '' (from gatsby-source-airtable default vals)
  Object.keys(filterOptions).forEach(f => {
    const filter = f as keyof FilterOptions
    const filterVals = filterOptions[filter].distinct

    // ignore columns with no real values, columns don't exist in Airtable
    if (filterVals.length === 1 && filterVals[0] === '') {
      return
    }

    if (coreFilters.length >= maxNumCoreFilters) {
      moreFilters.push({
        filterName: f,
        distinct: filterOptions[filter].distinct.filter(
          option => option !== ''
        ),
      })
    } else {
      coreFilters.push({
        filterName: f,
        distinct: filterOptions[filter].distinct.filter(
          option => option !== ''
        ),
      })
    }
  })

  return { coreFilters, moreFilters }
}
export default getFilters
